import React from 'react';

/**
 * Shows different content based on feature flags and can be dismissed.
 */

export const EngagementBanners = () => {
	return <></>;
};
